import { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";

export default function C_E_YEAR({
  tempValue,
  onChange,
  onBlur,
  onKeyDown,
  inPopup = false,
}) {
  const properties_state = useSelector((state) => state.properties);

  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);

  // Auto-focus on mount ONLY in table mode.
  // Doing this in popup mode will force the modal to scroll to the bottom.
  useEffect(() => {
    if (!inPopup && inputRef.current) {
      inputRef.current.focus();
    }
  }, [inPopup]);

  const handleLocalChange = (e) => {
    // 1. Strip everything EXCEPT digits (0-9). No decimals/points allowed.
    let val = e.target.value.replace(/[^0-9]/g, "");

    // 2. Cap the input at 4 digits max for a standard year format
    if (val.length > 4) {
      val = val.slice(0, 4);
    }

    // 3. Pass it up
    e.target.value = val;
    onChange(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    if (onBlur) onBlur(e);
  };

  // 1. POPUP MODE
  if (inPopup) {
    const mode_map = properties_state.mode_map; //editor || viewer

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <input
          disabled={mode_map !== "editor"}
          ref={inputRef}
          type="text"
          inputMode="numeric"
          value={tempValue || ""}
          onChange={handleLocalChange}
          onBlur={handleBlur}
          onFocus={() => setIsFocused(true)}
          onKeyDown={(e) => {
            // Pass Enter and Escape up to close the cell/save the data
            if (e.key === "Enter" || e.key === "Escape") {
              if (inputRef.current) {
                inputRef.current.blur();
              }
            }
            if (onKeyDown) onKeyDown(e);
          }}
          className="input"
          placeholder="YYYY"
          style={{ width: "100%", boxSizing: "border-box", textAlign: "left" }} // Usually left-aligned in forms
        />
        {isFocused && (
          <p
            className="text_small"
            style={{ margin: "4px 0 0 0", color: "#666" }}
          >
            Press Enter to save
          </p>
        )}
      </div>
    );
  }

  // 2. TABLE EDIT MODE
  return (
    <input
      ref={inputRef}
      type="text"
      inputMode="numeric"
      value={tempValue || ""}
      onChange={handleLocalChange}
      onBlur={handleBlur}
      onKeyDown={onKeyDown}
      className="input_table"
      placeholder="YYYY"
      style={{
        width: "100%",
        height: "100%",
        textAlign: "right", // Right-aligned in tables for numbers
        boxSizing: "border-box",
        paddingRight: "8px",
        outline: "none",
        border: "none",
        background: "transparent",
      }}
    />
  );
}
